import addWorkEquipment from "../../view/ppr/systems/add_work_equipment";

export default {
  ppr_systems: addWorkEquipment,
};
